<template>
	<div class="">

		<!--Merge button-->
		<section>
			<button class="btn btn-primary" v-on:click="visible = !visible">Merge User</button>
		</section>


		<!--Merge functionality-->
		<section>
			<div v-if="visible" class="container">
				<!--find user-->
				<div class="row">
					<h5>Type user email</h5>
				</div>
				<div class="row">
					<search-bar
							name="find"
							@close_search_event="closedSearch"
							@search_event="search_event"
							:close_search_action=true
					></search-bar>
				</div>

				<!--results-->
				<div v-if="found_users.length > 0" class="row">
					<h5>Displaying <b>{{found_users.length}}</b> users</h5>
					<table class="table table-bordered table-responsive-sm">
						<thead>
						<tr>
							<th>id</th>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Email</th>
							<th>Actions</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="user in found_users">
							<td>{{user.id}}</td>
							<td>{{user.first_name}}</td>
							<td>{{user.last_name}}</td>
							<td>{{user.email}}</td>
							<td>
								<button class="btn btn-danger" v-on:click="requestMerge(user)">Merge</button>
							</td>
						</tr>
						</tbody>
					</table>
				</div>

				<div v-else-if="has_searched" class="row">
					<span>(no results)</span>
				</div>

				<div v-else class="row">
					<span>Please enter more than 2 characters</span>
				</div>
			</div>
		</section>

		<!--generic error modal-->
		<section>
			<div class="modal-danger modal fade" id="confirmUserMergeModal" tabindex="-1" role="dialog"
				 aria-labelledby="confirmUserMergeModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-full-height modal-top" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="confirmUserMergeModalLabel">Merge Users</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div>
								<h5>Are you sure you want to continue?</h5>

								<div>
									<span class="font-weight-bold">This action is irreversible</span>
								</div>
							</div>

							<div class="container">
								<div class="row">
									<div class="col-5">
										<table class="table table-bordered table-responsive-sm">
											<thead>
											<tr>
												<th>id</th>
												<th>First Name</th>
												<th>Last Name</th>
												<th>Email</th>
											</tr>
											</thead>
											<tbody>
											<tr>
												<td>{{this_user.id}}</td>
												<td>{{this_user.first_name}}</td>
												<td>{{this_user.last_name}}</td>
												<td>{{this_user.email}}</td>
											</tr>
											</tbody>
										</table>
									</div>
									<div class="col-2">
										>>>>
									</div>
									<div class="col-5">
										<table v-if="selected_user != null" class="table table-bordered table-responsive-sm">
											<thead>
											<tr>
												<th>id</th>
												<th>First Name</th>
												<th>Last Name</th>
												<th>Email</th>
											</tr>
											</thead>
											<tbody>
											<tr>
												<td>{{selected_user.id}}</td>
												<td>{{selected_user.first_name}}</td>
												<td>{{selected_user.last_name}}</td>
												<td>{{selected_user.email}}</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>

							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button v-on:click="submitMerge()" type="button" class="btn btn-danger" data-dismiss="modal">Merge</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style>

</style>

<script>
    // add imports here
    import {_} from 'underscore';
	Vue.component('search-bar', require('../../../../../../app/Shared/Resources/Assets/js/components/SearchBar'));

    export default {
        props: ['url', 'this_user', 'find_user_url'],
        mounted() {

        },
        data() {
        	return {
				visible: false,

				found_users: [],
				has_searched: false,

				selected_user: null
            }
        },
        methods: {
        	//Search user functionality
        	searchUser(value){
        		let _this = this;

        		//Cannot allow to find with less characters than: 2
        		if (value.trim().length <= 2){
        			_this.has_searched = false;
        			return;
				}

        		axios.post(_this.find_user_url, {
        			input: value,
					length: 5
				})
					.then(function (response){
						_this.has_searched = true;
						_this.found_users = response.data.result;
					});
			},
        	search_event:_.debounce(function (value){
				this.searchUser(value);
			}, 300),


			closedSearch(){
        		this.found_users = [];
        		this.selected_user = null;
        		this.has_searched = false;
			},

			//Merge functionality
			requestMerge(user){
        		this.selected_user = user;

				$('#confirmUserMergeModal').modal('toggle');
			},

        	submitMerge(){
        		//We want to request the merge

				let _this = this;

				axios.post(_this.url, {
					original_user_id: _this.this_user.id,
					merge_to_user_id: _this.selected_user.id
				})
					.then(function (response) {
						if (response.data.success){
							window.location.href = response.data.url
						}
						else {
							toastr.error(response.data.error_msg);
						}
					})
			}
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/pages/users/MergeUsers.vue?0859ec82